// extracted by mini-css-extract-plugin
module.exports = {"container":"cover-image_container__3A8gA"};